import { CludoPhonebookSearch } from 'ui/components';
import { useSiteContext } from 'application/contexts/SiteContext';

export const CludoPhonebookSearchFeature: React.FC<Content.CludoPhonebookSearch> = ({ content }) => {
    const siteContext = useSiteContext();
    const cludoEngineId = siteContext.cludoEngineId;
    return (<CludoPhonebookSearch {...content?.properties} cludoEngineId={cludoEngineId} />)

};
